<template>
  <div>
    <breadcrumb :crumbs="crumbs">
      <div class="row d-flex align-items-center justify-content-end pr-15">
        <authorized-link tag="create_contract">
          <router-link :to="{ name: 'contracts_new'}" class="ls-btn-primary ls-no-margin ls-xs-margin-bottom">
            <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
            <span class="ls-xs-margin-left">{{ $t('application.button.new_contract') }}</span>
          </router-link>
        </authorized-link>
        <div v-if="contracts.length">
          <a class="ls-btn-primary ls-no-margin ls-xs-margin-bottom ls-xs-margin-left" @click="downloadCsv">{{ $t('contracts.main.export_csv') }}</a>
        </div>
      </div>
    </breadcrumb>
    <flash-message></flash-message>
    <br clear="all">
    <filter-contract></filter-contract>
    <div v-if="contracts.length">
      <div>
        <div class="ls-box-filter selected-items" v-if="activeSelected.length">
          <p class="ls-txt-center ls-display-inline-block">{{ $root.plural(activeSelected.length, 'contracts.main.selected_items') }}</p>
          <button class="ls-btn-danger ls-float-right" @click="setInactiveBatchData($event)">{{ $root.plural(activeSelected, 'contracts.main.inactive_subscription') }}</button>
        </div>
      </div>
      <table class="ls-table ls-table-striped ls-sm-space">
        <thead>
          <tr>
            <th width="5%"><input type="checkbox" v-model="selectAll" :disabled="activeContracts === 0" /></th>
            <th width="8%" class="hidden-xs">{{ $t('contracts.attributes.id') }}</th>
            <th width="8%" class="hidden-xs">{{ $t('contracts.attributes.code') }}</th>
            <th>{{ $t('contracts.main.client') }}</th>
            <th>{{ $t('contracts.main.subscription_value') }}</th>
            <th>{{ $t('contracts.main.charge_type')}}</th>
            <th class="hidden-sm hidden-md hidden-xs">{{ $t('contracts.main.contract_date') }}</th>
            <th class="hidden-xs">{{ $t('contracts.main.status') }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr data-test="contract" v-for="(contract, index) in filteredContracts(contracts)">
            <td>
              <input data-test="contract.select" type="checkbox" v-model="activeSelected" :disabled="contract.status !== 'active'" :value="index" :id="contract.id" number />
            </td>
            <td data-test="contract.id" class="hidden-xs">{{ contract.id }}</td>
            <td data-test="contract.code" class="hidden-xs">{{ contract.code }}</td>
            <td data-test="contract.customer.name">
              {{ contract.customer.name }}
              <small data-test="contract.customer.email" class="ls-display-block">{{ contract.customer.email }}</small>
            </td>
            <td data-test="contract.plan.price">R$ {{ money.parseViewValue(contractAmountValue(contract.contract_plans)) }}</td>
            <td data-test="contract.corp">{{ $t('contracts.attributes.charge_types.' + chargeType(contract) )}}</td>
            <td data-test="contract.date" class="hidden-sm hidden-md hidden-xs">{{ subscriptionDate(contract) }}</td>
            <td data-test="contract.status" :class="'hidden-xs ' + contract.status"><span class="ls-display-inline-block">{{ $t('contracts.attributes.statuses.' + contract.status) }}</span></td>
            <td>
              <regroup :width="970" class="ls-float-right">
                <router-link slot="button" :to="{ name: 'contract_details', params: { id: contract.id }}" class="ls-btn ls-no-margin">
                  <span>{{ $t('application.button.detail') }}</span>
                </router-link>
                <dropdown :list="true" slot="dropdown" :class="'ls-pos-right'">
                  <button slot="trigger" class="ls-btn ls-no-margin" role="combobox" aria-expanded="false"></button>
                  <ul slot="list" class="ls-dropdown-nav" aria-hidden="true">
                    <li v-if="contract.status === 'active'">
                      <authorized-link tag="destroy_contract">
                        <a href="javascript:void(0)" @click="setInactiveData(contract, index)" class="ls-color-danger">{{ $t('application.button.inactive') }}</a>
                      </authorized-link>
                    </li>
                  </ul>
                </dropdown>
              </regroup>
            </td>
          </tr>
        </tbody>
      </table>
      <modal-inactive v-model="inactiveObjects"></modal-inactive>
      <modal-inactive-batch v-model="inactiveBatchObjects"></modal-inactive-batch>
    </div>
    <div v-else role="alert">
      <empty-list></empty-list>
    </div>
    <pagination :updater="getContracts"></pagination>
  </div>
</template>
<script>
  import { mapActions, mapMutations, mapGetters } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import EmptyList from 'src/app/components/shareds/empty-list/EmptyList'
  import Filter from './components/Filter'
  import ModalInactive from './components/ModalInactive'
  import ModalInactiveBatch from './components/ModalInactiveBatch'
  import Pagination from 'src/app/components/shareds/pagination/Pagination'
  import filter from 'src/utils/filter'
  import Browser from 'src/utils/browser'
  import _ from 'lodash'
  import money from 'src/utils/money'
  import date from 'src/utils/date'
  import scroll from 'src/utils/scroll'
  import Dropdown from 'src/app/components/shareds/dropdown/Dropdown'
  import Regroup from 'src/app/components/shareds/regroup/Regroup'

  export default {
    name: 'indexContracts',
    components: {
      Breadcrumb,
      FilterContract: Filter,
      Pagination,
      ModalInactive,
      ModalInactiveBatch,
      Dropdown,
      Regroup,
      EmptyList
    },
    data () {
      return {
        inactiveObjects: { show: false },
        inactiveBatchObjects: { show: false, indexes: [] },
        money: money,
        date: date,
        activeSelected: [],
        index: '',
        crumbs: {
          'ico': 'ls-ico-week',
          'section': this.$t('contracts.main.subscriptions_list'),
          'paths': {
            0: {
              'title': this.$t('contracts.edit.subscriptions'),
              'path': ''
            }
          }
        }
      }
    },
    mounted () {
      this.getFromUrl()
      this.getContracts()
      this.$watch('contracts', function (newVal) {
        this.activeSelected = []
        this.setPageData(newVal)
      })
    },
    computed: {
      ...mapGetters(['contracts', 'filterContracts', 'pagination']),
      selectAll: {
        get: function () {
          return this.contracts ? this.activeSelected.length > 0 && this.activeSelected.length === this.activeContracts : false
        },
        set: function (value) {
          this.activeSelected = []
          if (value) {
            for (var i = 0; i < this.contracts.length; i++) {
              if (this.contracts[i].status === 'active') this.activeSelected.push(i)
            }
          }
        }
      },
      activeContracts () {
        var count = 0
        for (var i in this.contracts) {
          if (this.contracts[i].status === 'active') count += 1
        }
        return count
      }
    },
    methods: {
      ...mapActions(['loadContracts', 'getCsvContracts']),
      ...mapMutations(['setContract', 'setPageData', 'clearFilterContracts', 'clearPlans', 'clearFlash']),
      getContracts () {
        this.startLoading()
        var params = filter.toQueryWithPagination(this.filterContracts, this.pagination, 10)
        this.saveOnUrl()
        this.loadContracts(params).then(this.afterLoad)
      },
      subscriptionDate: function (contract) {
        return contract.status !== 'pending' ? date.parseDate(contract.activated_at) : '-'
      },
      afterLoad () {
        this.stopLoading()
      },
      getFromUrl () {
        Browser.recoverFilterFromURL(this.$route, this.filterContracts, this.pagination)
      },
      chargeType (contract) {
        return contract.post_paid ? 'post_paid' : 'pre_paid'
      },
      saveOnUrl () {
        var paginationUrlParams = { current_page: this.pagination.current_page, per_page: this.pagination.per_page }
        Browser.filtersToURL(this.$router, _.merge(this.filterContracts, paginationUrlParams), 'contracts')
      },
      filteredContracts (contracts) {
        return contracts.filter(function (contract) {
          return contract.customer !== null
        })
      },
      afterInactive () {
        this.clearSelection()
        scroll.scrollToFlash()
      },
      contractAmountValue (contractPlans) {
        let amountDue = 0
        for (let contractPlan of contractPlans) {
          if (contractPlan.status === 'active') {
            amountDue += parseFloat(contractPlan.price)
          }
        }
        return amountDue
      },
      clearSelection () {
        this.activeSelected = []
      },
      startLoading () {
        this.$loader.show()
      },
      stopLoading () {
        this.$loader.hide()
      },
      setInactiveData (contract, index, event) {
        this.setContract(contract)
        this.inactiveObjects.index = index
        this.inactiveObjects.show = true
        this.inactiveObjects.callback = this.afterInactive
      },
      setInactiveBatchData (event) {
        this.inactiveBatchObjects.show = true
        this.inactiveBatchObjects.contracts = this.contracts
        this.inactiveBatchObjects.indexes = this.activeSelected
        this.inactiveBatchObjects.stopLoading = this.stopLoading
        this.inactiveBatchObjects.startLoading = this.startLoading
        this.inactiveBatchObjects.callback = this.afterInactive
      },
      downloadCsv () {
        this.clearFlash()
        this.startLoading()
        var params = filter.toQueryWithPagination(this.filterContracts, this.pagination, 10)
        filter.toQueryWithPagination({}, this.pagination, 999)
        this.getCsvContracts(params).then(this.afterLoad)
      },
      clearFilter () {
        this.$children[0].$emit('clearFilters')
      }
    },
    beforeDestroy () {
      this.clearFilterContracts()
      this.clearPlans()
    }
  }
</script>
<style scoped lang="scss">
  .selected-items {
    p {
      margin: 8px 0 8px;
      + [class*="ls-btn"] {
        margin-top: 0;
      }
    }
  }
  .ls-width-150-md {
    @media(min-width: 900px) {
      width: 150px !important;
    }
  }
  .d-flex {
    display: flex;
  }
  .align-items-center {
    align-items: center;
  }
  .justify-content-end {
    justify-content: flex-end;
  }
  .pr-15 {
    padding-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// Main.vue?bb5cf8be